import { VisibilityOffOutlined } from "@mui/icons-material";
import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import { Translations } from "ui/Scripts/source/models/translations";

interface IListStateIconPrivateProps {
    noMargin?: boolean;
    tooltip?: string;
}

export const ListStateIconPrivate = (props: IListStateIconPrivateProps) => {
    return (
        <ListStateIcon
            tooltip={props.tooltip ?? Translations.Private}
            icon={VisibilityOffOutlined}
            noMargin={props.noMargin}
        />
    );
};
